import { render, staticRenderFns } from "./OverTimePlanDetailsInfo.vue?vue&type=template&id=2f147458&scoped=true&"
import script from "./OverTimePlanDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./OverTimePlanDetailsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f147458",
  null
  
)

export default component.exports